import React from 'react';
import { useBreakpoint } from 'theming/hooks/useBreakpoint';
export const GridContext = /*#__PURE__*/React.createContext({
  breakpoint: null
});
export const GridContextProvider = ({
  children,
  columnWidth
}) => {
  const breakpoint = useBreakpoint();
  const defaultColumnWidth = columnWidth ?? 1;
  return /*#__PURE__*/React.createElement(GridContext.Provider, {
    value: {
      breakpoint,
      defaultColumnWidth
    }
  }, children);
};